export const capitalize = (input: string): string =>
  input.charAt(0).toUpperCase() + input.substring(1);

export const uncapitalize = <S extends string>(input: S): Uncapitalize<S> =>
  (input.substring(0, 1).toLowerCase() + input.substring(1)) as Uncapitalize<S>;

export const withEnv = (input: string, env = "") =>
  env === "prod" || !env ? input : `${input} (${env.toUpperCase()})`;

export const isOnlyNumbers = (str: string) => /^\d+$/.test(str);

export const removeStopNameSuffixes = (stopName: string): string =>
  stopName.replace(/ \w*(stasjon|station)\s*$/i, "");

export const normalizeScandinavianCharacters = (input: string) =>
  input
    .replace(/ä|æ/g, "ae")
    .replace(/ö|ø/g, "o")
    .replace(/Ä|Æ/g, "Ae")
    .replace(/Ö|Ø/g, "O");
